import React from "react";
import Dialog from "@mui/material/Dialog";
import PropTypes from "prop-types";

import LandingTypography from "../../../landingPage/components/LandingTypography";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";

const StrategyBenchmarkChartFullscreenModal = ({
  open,
  onClose,
  children
}) => {
  const isDesktop = useIsDesktop();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={!isDesktop}
      maxWidth="lg"
      fullWidth
      classes={{
        paper: "strategy-benchmark-chart__modal-paper"
      }}
    >
      <div className="strategy-benchmark-chart__modal">
        <button
          type="button"
          className="strategy-benchmark-chart__modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          <i className="fal fa-times" aria-hidden="true" />
        </button>
        <LandingTypography className="landing-typography_dark">{children}</LandingTypography>
      </div>
    </Dialog>
  );
};

StrategyBenchmarkChartFullscreenModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default StrategyBenchmarkChartFullscreenModal;
